import {memo} from 'react';
import Container from 'react-bootstrap/Container';
import Footer from './footer/MainFooter';
import { NavBarProvider } from '../context/NavBarContext'

const MainContainer = ({ children }) => {
    return (
        <Container>
            <NavBarProvider>
                <main role="main" className='content-body'>
                    <div className="container">
                        {children}
                    </div>
                </main>
            </NavBarProvider>
            <Footer />
        </Container>
    );
}

export default memo(MainContainer);